/**
 * Logo List - Mobile Marquee
 * Handles touch pause and reduced motion preferences
 */
(function () {
  'use strict';

  const marquees = document.querySelectorAll('.logo-list__marquee');

  if (!marquees.length) return;

  // Check for reduced motion preference
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function handleReducedMotion(event) {
    marquees.forEach(function (marquee) {
      const track = marquee.querySelector('.logo-list__marquee-track');
      if (!track) return;

      if (event.matches) {
        track.style.animationPlayState = 'paused';
      } else {
        track.style.animationPlayState = 'running';
      }
    });
  }

  prefersReducedMotion.addEventListener('change', handleReducedMotion);

  // Pause on touch for mobile
  marquees.forEach(function (marquee) {
    const track = marquee.querySelector('.logo-list__marquee-track');
    if (!track) return;

    marquee.addEventListener(
      'touchstart',
      function () {
        track.style.animationPlayState = 'paused';
      },
      { passive: true }
    );

    marquee.addEventListener(
      'touchend',
      function () {
        track.style.animationPlayState = 'running';
      },
      { passive: true }
    );
  });
})();
